export default function isObjectEmpty(obj) {
  return !Object.values(obj).some((value) => !!value);
}
